import React from "react";
import {
    BUTTON_DISPLAY_ANIMATION_CLASS,
    CARD_CONTAINER_WITH_BACKGROUND_CLASS,
    CARD_INNER_CONTAINER_CLASS,
    HOVER_VISIBLE,
    INNER_CONTAINER_FOR_TEXT,
    SPACE,
} from "./constants";
import PrimaryButton from "../../Atoms/Buttons/PrimaryButton/PrimaryButton";
import StylistCardTitle from "../../Atoms/Typography/StylistCardTitle/StylistCardTitle";
import StylistCardInstagram from "../../Atoms/Typography/StylistCardInstagram/StylistCardInstagram";
import StylistCardDescription from "../../Atoms/Typography/StylistCardDescription/StylistCardDescription";
import {
    ENGLISH,
    SIGN_UP_ENDPOINT,
    TABLET_SCREEN,
    TEXT_LEFT,
    TEXT_RIGHT,
} from "../../../public/Constants/EnumConstants";
import classNames from "classnames";
import { sendGTMEvent } from "@next/third-parties/google";

const StylistCard = ({
    description,
    image,
    alignment,
    index,
    instagram,
    name,
    link,
    profileButtonText,
    buttonText,
    mobileButtonText,
}) => {
    const textConatinerClass = classNames(
        INNER_CONTAINER_FOR_TEXT,
        alignment === ENGLISH ? TEXT_LEFT : TEXT_RIGHT
    );
    return (
        <div
            key={index}
            className={CARD_CONTAINER_WITH_BACKGROUND_CLASS}
            style={{
                backgroundImage: `url(${image?.url})`,
            }}
            loading="lazy"
        >
            <div className={CARD_INNER_CONTAINER_CLASS}>
                <div className={HOVER_VISIBLE}>
                    <StylistCardTitle text={name} alignment={alignment} />
                    <div className={textConatinerClass}>
                        <StylistCardDescription
                            text={description}
                            alignment={alignment}
                        />
                        <StylistCardInstagram
                            text={instagram}
                            alignment={alignment}
                        />
                    </div>
                    <PrimaryButton
                        text={profileButtonText}
                        className={BUTTON_DISPLAY_ANIMATION_CLASS}
                        href={link}
                        onClick={() => {
                            sendGTMEvent({
                                event: "view_stylist_profile",
                                stylist_name: name,
                                content_id: "ViewProfileClick",
                            });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default StylistCard;
